module.exports = __webpack_public_path__ + "img/ring_0_0_null_1@2x.54b60270.png";